// SST V2 reservation timestamps (`expiration`, `_created`, `delivery_time`,
// `reception_time`, envelope `timestamp`, …) are emitted as naive UTC strings
// — no Z / offset, but the value IS UTC. Formats seen in the wild:
//   "YYYY-MM-DD HH:mm:ss"          (expiration)
//   "YYYY-MM-DDTHH:mm:ss.ssssss"   (delivery/reception, µs, no Z)
// `new Date(str)` / `moment(str)` parse non-offset formats as browser-local,
// which drifts by the operator's TZ offset (+4h/+5h in America/Toronto).
// Convert to a proper ISO UTC string before parsing.

/**
 * Parse a naive UTC SST V2 datetime string into a JS Date.
 * Accepts the SST wire formats above, or full ISO 8601 with Z/offset
 * (no-op fallback for OLAP / older data that already carries an offset).
 */
export function parseSst2Utc(naive: string | null | undefined): Date | null {
  if (!naive) return null
  // If a Z or offset is already present, parse as-is.
  const hasOffset = /Z|[+-]\d{2}:?\d{2}$/.test(naive)
  const iso = hasOffset
    ? naive.includes("T")
      ? naive
      : naive.replace(" ", "T")
    : (naive.includes("T") ? naive : naive.replace(" ", "T")) + "Z"
  const ms = Date.parse(iso)
  return Number.isNaN(ms) ? null : new Date(ms)
}
